export default ({
  highlightRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const highlights = await highlightRepository.fetchHighlights({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ highlights})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
